import AddIcon from '@clearkit/icons/glyphs/AddBlock';
import { CKButton } from '@clearkit/react';
import { Link } from 'react-router-dom';

import paths from '~/lib/paths';
import { readableSingularSegmentType } from '~/lib/segments';

import styles from './styles.style';

function NewSegmentButton({ classes, className, type }) {
  return (
    <CKButton
      variant="simple"
      variantColor="green"
      as={Link}
      to={paths.segmentNew(type)}
      leftIcon={<AddIcon className={classes.newSegmentButtonIcon} />}
      className={classnames(className, classes.newSegmentButton)}>
      New {readableSingularSegmentType(type)} segment
    </CKButton>
  );
}

NewSegmentButton.propTypes = {
  classes: PropTypes.object,
  className: PropTypes.string,
  type: PropTypes.oneOf(['Company', 'Person']).isRequired,
};

export default withStyles(styles)(NewSegmentButton);
